﻿'use strict';

angular.module('ntmApp').factory('ListGridPaging', function () {

    function ListGridPaging(pageObj) {

        var self = this;

        self.hasPagination = function () {
            return pageObj ? true : false;
        };

        self.getPageSize = function () {
            return pageObj ? pageObj.pageSize : null;
        };

        self.getPageSizes = function () {
            return pageObj ? pageObj.pageSizes : null;
        };

    }

    return (ListGridPaging);
});